import type { FaireProductEntity } from "../../entity_types/product";

export const p_6pnngsy5n8: FaireProductEntity = {
  token: "p_6pnngsy5n8",
  type: "product",
  name: "Mermaid Theme Bath Bomb Gift Set (Pink Box) | A099",
  brandToken: "b_vq4dxxsy59",
  brandName: "Prime Opticals",
  imageUrl:
    "https://cdn.faire.com/fastly/f235b9e9ea2fa38244d77d510cebc60b27d1740e9725ad9300d88202b944a0ba.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc986b4087c854e99b379509e654408d89fb3b3ddbf45ead32c04a302561a58f.jpeg",
    "https://cdn.faire.com/fastly/c02e16c386bbe3ef131487ba5bccad4ae0cf026659a6961210a9bc5ff13925ca.jpeg",
  ],
  priceDollars: 1.35,
  description:
    "AI is hyping up all these bath bomb products, so lets join the hype! Bring back what was hot since covid-era which were all these bath bomb products! Everything is packed by 12 with assorted scents and a gift in the middle!",
  tags: [],
  msrpDollars: 3.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:35.998Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
